import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { InvoiceSummaryComponent } from "src/app/pages/finance/payment/invoice-summary/invoice-summary.component";
import { StudentService } from "src/app/services/http/business/student/student.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IError } from "src/app/interfaces/error.interface";
import { GonbadSettingService } from "src/app/services/http/business/gonbadSetting/gonbadSetting.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-confirm-registration-entry",
  templateUrl: "./confirm-registration-entry.component.html",
  styleUrls: ["./confirm-registration-entry.component.css"]
})
export class ConfirmRegistrationEntryComponent implements OnInit {
  errObject: any;
  param: any;
  errorList: IError[] = [];
  userInfo: any;
  errors = new Array();
  course:any;

  conditions: SafeHtml = '';

  constructor(
    //private router: Router,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private studentService: StudentService,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef: MatDialogRef<ConfirmRegistrationEntryComponent>,
    private gonbadSettingService: GonbadSettingService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.userInfo=JSON.parse(window.localStorage.getItem('userInfo'));
    this.getCourseInfo();

    this.getConditions();
  }

  getConditions(): void
  {
    this.gonbadSettingService.listGonbadSetting("Conditions").subscribe({
      next: (res: any) =>
      {

        this.conditions = this.sanitizer.bypassSecurityTrustHtml(res[0].KeyValue);
        
      }
    })
  }


  getCourseInfo() {

    let params={
      Id:this.data.CourseId
    };
    this.studentService.getCourseInfoById(params).subscribe(res => {

       this.course = res;
    }
     );
  }

  finalCOnfirm() {

    let command : any = {
      Id: this.data.Id,
      CourseTypeId: this.data.CourseTypeId,
      TermInfoId: this.data.TermInfoId,
      CourseId: this.data.CourseId,
      LevelInfoId: this.data.LevelInfoId,
      BranchEncryptId: this.data.BranchEncryptId,
      DiscountGroupId: this.data.DiscountGroupId,
      GetUnderstandingDiscountId:this.data.GetUnderstandingDiscountId
    };
    //ثبت، ثبت نام جدید برای دانشجو
    this.studentService.add(command).subscribe(() => {
      {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.createCourse"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }
      this.dialogRef.close();
      //this.router.navigate(["management/finance/invoice"]);
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      });
  }

  navigateToPaymanet() {

   let command : any = {
      CourseTypeId: this.data.CourseTypeId,
      TermInfoId: this.data.TermInfoId,
      CourseId: this.data.CourseId,
      LevelInfoId: this.data.LevelInfoId,
      BranchEncryptId: this.data.BranchEncryptId,
      DiscountGroupId: this.data.DiscountGroupId,
      GetUnderstandingDiscountId:this.data.GetUnderstandingDiscountId,
      Id: this.data.Id
    };
     //ثبت، ثبت نام جدید برای دانشجو
    this.studentService.add(command).subscribe(res => {
      {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.createCourse"),
          "ok",
          5000,
          SoundEnum.beep
        );
      }

      this.dialogRef.close();
      res["IsStudent"]=true;
      this.dialog.open(InvoiceSummaryComponent, {
        width: '98%',
        data: {Id:parseInt(res.returnValue), IsStudent: res.IsStudent}
      })
        .afterClosed()
        .subscribe(() => {
          this.dialogRef.close();
        });
    },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      });
  }

  onCLose() {
    this.dialogRef.close();
  }
}
